
export async function instantiate(imports={}, runInitializer=true) {
    imports['_cachedJsObjects_'] = imports['_cachedJsObjects_'] ?? new WeakMap();
    const cachedJsObjects = imports['_cachedJsObjects_'];

    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }


    imports['./skiko.mjs'] = imports['./skiko.mjs'] ?? await import('./skiko.mjs');
    imports['@js-joda/core'] = imports['@js-joda/core'] ?? await import('@js-joda/core');

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.Date_$external_fun' : () => new Date(),
        'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
        'kotlin.uuid.get' : (array, index) => array[index],
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.transform_$external_prop_setter' : (_this, v) => _this.transform = v,
        'org.w3c.dom.css.transition_$external_prop_setter' : (_this, v) => _this.transition = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
        'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
        'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
        'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
        'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
        'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.querySelectorAll_$external_fun' : (_this, p0) => _this.querySelectorAll(p0),
        'org.w3c.dom.pushState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.pushState(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.innerHTML_$external_prop_setter' : (_this, v) => _this.innerHTML = v,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
        'org.w3c.dom.remove_$external_fun' : (_this, p0) => _this.remove(...p0),
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
        'org.w3c.dom.Node_$external_class_get' : () => Node,
        'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
        'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
        'org.w3c.dom.Touch_$external_class_get' : () => Touch,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun_1' : (_this, ) => _this.remove(),
        'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
        'org.w3c.dom.HTMLFormElement_$external_class_instanceof' : (x) => x instanceof HTMLFormElement,
        'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
        'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.dom.url.URLSearchParams_$external_fun' : (p0, isDefault0) => new URLSearchParams(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.url.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
        'org.w3c.fetch.Response_$external_class_get' : () => Response,
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
        'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
        'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
        'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
        'com.apollographql.apollo.mpp.currentTimeMillis2' : () => (new Date()).getTime(),
        'com.apollographql.apollo.network.http.newAbortController' : () => new AbortController(),
        'com.apollographql.apollo.network.http.getKeys' : (headers) => Array.from(headers.keys()),
        'com.apollographql.apollo.network.http.makeJsObject' : () => { return {}; },
        'com.apollographql.apollo.network.http.setObjectField' : (obj, name, value) => obj[name]=value,
        'com.apollographql.apollo.network.http.toJsArrayImpl' : (x) => new Uint8Array(x),
        'com.apollographql.apollo.network.http.signal_$external_prop_getter' : (_this) => _this.signal,
        'com.apollographql.apollo.network.http.abort_$external_fun' : (_this, ) => _this.abort(),
        'com.apollographql.apollo.network.http.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'com.apollographql.apollo.network.http.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'com.apollographql.apollo.network.http.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'com.apollographql.apollo.network.http.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'com.apollographql.apollo.network.http.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'com.apollographql.apollo.network.http.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'com.apollographql.apollo.network.http.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'com.apollographql.apollo.network.http.read_$external_fun' : (_this, ) => _this.read(),
        'com.apollographql.apollo.network.http.done_$external_prop_getter' : (_this) => _this.done,
        'com.apollographql.apollo.network.http.value_$external_prop_getter' : (_this) => _this.value,
        'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
        'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
        'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
        'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
                   return new Intl.Locale(locale).weekInfo.firstDay; 
                } catch (error) { 
                   return -1; 
              }},
        'androidx.compose.material3.internal.getIs24HourFormat' : (localeTag) => {
                    var locale = new Intl.Locale(localeTag);
                    // Check for the hourCycles property first
                    if (locale.hourCycles) {
                        return locale.hourCycles.includes('h23') || locale.hourCycles.includes('h24') ? 1 : 0;
                    }
        
                    // Fallback to hourCycle property
                    if (locale.hourCycle) {
                        return locale.hourCycle === 'h23' || locale.hourCycle === 'h24' ? 1 : 0;
                    }
                    return -1;
                },
        'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
        'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
        'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
        'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
        'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
        'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
        'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
        'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
        'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
        'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
        'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
        'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
        'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
        'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
        'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
        'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
        'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
        'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
        'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
        'kotlinx.io.node.requireExists' : () => typeof require === 'function',
        'kotlinx.io.node.requireModule' : (mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
         },
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process.env.KTOR_LOG_LEVEL,
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'com.capawble.shared.auth.jsInitializeApp' : (configJson) => firebase.initializeApp(JSON.parse(configJson)),
        'com.capawble.shared.auth.jsUseAuthEmulator' : (url) => firebase.auth().useEmulator(url),
        'com.capawble.shared.auth.jsOnAuthStateChanged' : (onUser, onSignedOut) => {
            return firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    onUser(user.uid, user.email || '', user.displayName || '');
                } else {
                    onSignedOut();
                }
            });
        },
        'com.capawble.shared.auth.__convertKotlinClosureToJsClosure_((Js,Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Js,Js,Js)->Unit)'](f, p0, p1, p2)),
        'com.capawble.shared.auth.jsSignIn' : (email, pw, onSuccess, onError) => {
            firebase.auth().signInWithEmailAndPassword(email, pw)
                .then(function(cred) {
                    var u = cred.user;
                    onSuccess(u.uid, u.email || '', u.displayName || '');
                })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Authentication failed'); });
        },
        'com.capawble.shared.auth.__convertKotlinClosureToJsClosure_((Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Unit)'](f, p0, p1)),
        'com.capawble.shared.auth.jsSendSignInLinkToEmail' : (email, continueUrl, onComplete, onError) => {
            var settings = { url: continueUrl, handleCodeInApp: true };
            firebase.auth().sendSignInLinkToEmail(email, settings)
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Failed to send sign-in link'); });
        },
        'com.capawble.shared.auth.jsSignInWithEmailLink' : (email, url, onSuccess, onError) => {
            firebase.auth().signInWithEmailLink(email, url)
                .then(function(cred) {
                    var u = cred.user;
                    onSuccess(u.uid, u.email || '', u.displayName || '');
                })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Sign-in failed'); });
        },
        'com.capawble.shared.auth.jsSendPasswordResetEmail' : (email, onComplete, onError) => {
            firebase.auth().sendPasswordResetEmail(email)
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Could not send the reset email'); });
        },
        'com.capawble.shared.auth.jsSignInWithGoogle' : (onSuccess, onError) => {
            var provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider)
                .then(function(cred) {
                    var u = cred.user;
                    onSuccess(u.uid, u.email || '', u.displayName || '');
                })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Google sign-in failed'); });
        },
        'com.capawble.shared.auth.jsSignInWithApple' : (onSuccess, onError) => {
            var provider = new firebase.auth.OAuthProvider('apple.com');
            firebase.auth().signInWithPopup(provider)
                .then(function(cred) {
                    var u = cred.user;
                    onSuccess(u.uid, u.email || '', u.displayName || '');
                })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Apple sign-in failed'); });
        },
        'com.capawble.shared.auth.jsLinkedProviders' : (onItem, onDone) => {
            var user = firebase.auth().currentUser;
            if (!user) { onDone(); return; }
            var emit = function() {
                var current = firebase.auth().currentUser;
                if (current) {
                    current.providerData.forEach(function(p) {
                        if (p) { onItem(p.providerId || '', p.email || ''); }
                    });
                }
                onDone();
            };
            // Refreshed first, so a method added on another device is listed here. A failed refresh falls back to
            // what this browser already knows rather than failing the list.
            user.reload().then(emit, emit);
        },
        'com.capawble.shared.auth.jsLinkWithGoogle' : (onComplete, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onError('auth/no-current-user', 'No signed-in user'); return; }
            user.linkWithPopup(new firebase.auth.GoogleAuthProvider())
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Adding Google failed'); });
        },
        'com.capawble.shared.auth.jsLinkWithApple' : (onComplete, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onError('auth/no-current-user', 'No signed-in user'); return; }
            user.linkWithPopup(new firebase.auth.OAuthProvider('apple.com'))
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Adding Apple failed'); });
        },
        'com.capawble.shared.auth.jsLinkWithEmailLink' : (email, url, onComplete, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onError('auth/no-current-user', 'No signed-in user'); return; }
            if (!firebase.auth().isSignInWithEmailLink(url)) { onError('auth/invalid-action-code', 'Not an email sign-in link'); return; }
            user.linkWithCredential(firebase.auth.EmailAuthProvider.credentialWithLink(email, url))
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Adding the email address failed'); });
        },
        'com.capawble.shared.auth.jsReauthenticateWithGoogle' : (onComplete, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onError('auth/no-current-user', 'No signed-in user'); return; }
            user.reauthenticateWithPopup(new firebase.auth.GoogleAuthProvider())
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Confirming with Google failed'); });
        },
        'com.capawble.shared.auth.jsReauthenticateWithApple' : (onComplete, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onError('auth/no-current-user', 'No signed-in user'); return; }
            user.reauthenticateWithPopup(new firebase.auth.OAuthProvider('apple.com'))
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.code || 'unknown', err.message || 'Confirming with Apple failed'); });
        },
        'com.capawble.shared.auth.jsSignOut' : (onComplete, onError) => {
            firebase.auth().signOut()
                .then(function() { onComplete(); })
                .catch(function(err) { onError(err.message || 'Sign out failed'); });
        },
        'com.capawble.shared.auth.jsGetIdToken' : (forceRefresh, onSuccess, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onSuccess(''); return; }
            user.getIdToken(forceRefresh)
                .then(function(token) { onSuccess(token); })
                .catch(function(err) { onError(err.message || 'Token fetch failed'); });
        },
        'com.capawble.shared.auth.jsGetIdTokenResult' : (onSuccess, onError) => {
            var user = firebase.auth().currentUser;
            if (!user) { onSuccess('{}'); return; }
            user.getIdTokenResult()
                .then(function(result) { onSuccess(JSON.stringify(result.claims || {})); })
                .catch(function(err) { onError(err.message || 'Claims fetch failed'); });
        },
        'com.capawble.shared.config.jsConfigGraphqlUrl' : () => window.__CAPAWBLE_CONFIG__?.graphqlUrl || '',
        'com.capawble.shared.config.jsConfigFirebaseApiKey' : () => window.__CAPAWBLE_CONFIG__?.firebaseApiKey || '',
        'com.capawble.shared.config.jsConfigFirebaseProjectId' : () => window.__CAPAWBLE_CONFIG__?.firebaseProjectId || '',
        'com.capawble.shared.config.jsConfigUseEmulator' : () => window.__CAPAWBLE_CONFIG__?.useEmulator === true,
        'com.capawble.shared.config.jsConfigEnvironment' : () => window.__CAPAWBLE_CONFIG__?.environment || 'production',
        'com.capawble.shared.config.jsConfigErrorReportingUrl' : () => window.__CAPAWBLE_CONFIG__?.errorReportingUrl || '',
        'com.capawble.shared.config.jsConfigAppVersion' : () => window.__CAPAWBLE_CONFIG__?.appVersion || '1.0.0',
        'com.capawble.shared.error.jsFetchPost' : (url, body, sessionId) => {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Client-Session-Id': sessionId },
                body: body
            }).catch(function() {});
        },
        'com.capawble.shared.error.jsDateNow' : () => Date.now(),
        'com.capawble.shared.error.jsInstallGlobalErrorHandlers' : (reportError) => {
            window.onerror = function(msg, source, line, col, error) {
                reportError(String(msg), error ? error.stack || '' : '', (source || '') + ':' + line + ':' + col);
                return false;
            };
            window.addEventListener('unhandledrejection', function(event) {
                var reason = event.reason;
                var msg = reason instanceof Error ? reason.message : String(reason);
                var stack = reason instanceof Error ? reason.stack || '' : '';
                reportError(msg, stack, 'unhandledrejection');
            });
        },
        'com.capawble.shared.logging.jsConsoleLog' : (json) => console.log(json),
        'com.capawble.shared.logging.jsConsoleWarn' : (json) => console.warn(json),
        'com.capawble.shared.logging.jsConsoleError' : (json) => console.error(json),
        'com.capawble.shared.logging.jsNowIso' : () => new Date().toISOString(),
        'com.capawble.shared.performance.jsPerformanceMark' : (name) => performance.mark(name),
        'com.capawble.shared.performance.jsPerformanceMeasure' : (name, startMark, endMark) => { try { performance.measure(name, startMark, endMark); } catch(e) {} },
        'com.capawble.shared.performance.jsPerformanceNow' : () => performance.now(),
        'com.capawble.shared.performance.jsNavigationTiming' : () => {
            const nav = performance.getEntriesByType('navigation')[0];
            if (!nav) return '';
            return JSON.stringify({
                ttfb: Math.round(nav.responseStart - nav.requestStart),
                dns: Math.round(nav.domainLookupEnd - nav.domainLookupStart),
                tls: Math.round(nav.connectEnd - nav.secureConnectionStart),
                download: Math.round(nav.responseEnd - nav.responseStart),
                domReady: Math.round(nav.domContentLoadedEventEnd - nav.fetchStart)
            });
        },
        'com.capawble.shared.platform.jsStopRecording' : (onResult, onError) => {
            var state = window.__capawbleRecorder;
            if (!state || !state.recorder) {
                onError('No recording in progress');
                return;
            }
            var recorder = state.recorder;
            recorder.onstop = function() {
                var blob = new Blob(state.chunks, { type: 'audio/webm' });
                var durationSec = Math.round((Date.now() - state.startTime) / 1000);
                state.stream.getTracks().forEach(function(t) { t.stop(); });
                window.__capawbleRecorder = null;
                var reader = new FileReader();
                reader.onload = function() {
                    var arr = new Uint8Array(reader.result);
                    var bytes = [];
                    for (var i = 0; i < arr.length; i++) { bytes.push(arr[i]); }
                    onResult(bytes, durationSec);
                };
                reader.onerror = function() {
                    onError('Failed to read recorded audio');
                };
                reader.readAsArrayBuffer(blob);
            };
            recorder.stop();
        },
        'com.capawble.shared.platform.__convertKotlinClosureToJsClosure_((Js,Int)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Int)->Unit)'](f, p0, p1)),
        'com.capawble.shared.platform.jsLen' : (arr) => arr.length,
        'com.capawble.shared.platform.jsGet' : (arr, i) => arr[i],
        'com.capawble.shared.platform.jsCancelRecording' : () => {
            var state = window.__capawbleRecorder;
            if (state && state.recorder) {
                try { state.recorder.stop(); } catch(e) {}
                state.stream.getTracks().forEach(function(t) { t.stop(); });
                window.__capawbleRecorder = null;
            }
        },
        'com.capawble.shared.platform.jsIsRecordingSupported' : () => {
            return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && typeof MediaRecorder !== 'undefined');
        },
        'com.capawble.shared.platform.jsStartRecording' : (onReady, onError) => {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                onError('MediaRecorder not supported');
                return;
            }
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(function(stream) {
                    var chunks = [];
                    var startTime = Date.now();
                    var recorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
                    recorder.ondataavailable = function(e) {
                        if (e.data.size > 0) chunks.push(e.data);
                    };
                    window.__capawbleRecorder = {
                        recorder: recorder,
                        stream: stream,
                        chunks: chunks,
                        startTime: startTime
                    };
                    recorder.start();
                    onReady();
                })
                .catch(function(err) {
                    onError(err.message || 'Microphone access denied');
                });
        },
        'com.capawble.shared.platform.jsBrowserSharesFiles' : () => {
            try {
                var probe = new File([new Blob([''], { type: 'application/pdf' })], 'probe.pdf', { type: 'application/pdf' });
                return !!(navigator.share && navigator.canShare && navigator.canShare({ files: [probe] }));
            } catch (e) {
                return false;
            }
        },
        'com.capawble.shared.platform.jsFileFromBlob' : (blob, fileName, mimeType) => new File([blob], fileName, { type: mimeType }),
        'com.capawble.shared.platform.jsCanShareFile' : (file) => {
            try { return !!(navigator.share && navigator.canShare && navigator.canShare({ files: [file] })); }
            catch (e) { return false; }
        },
        'com.capawble.shared.platform.jsShareFile' : (file, text, onRejected) => {
            var data = { files: [file] };
            if (text) data.text = text;
            try {
                navigator.share(data).then(function() {}, function(e) { onRejected(e && e.name ? e.name : ''); });
            } catch (e) {
                onRejected(e && e.name ? e.name : '');
            }
        },
        'com.capawble.shared.platform.jsDownloadBlob' : (blob, fileName) => {
            var url = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
        },
        'com.capawble.shared.platform.jsBlobFromBase64' : (base64, mimeType) => {
            var binary = atob(base64);
            var bytes = new Uint8Array(binary.length);
            for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            return new Blob([bytes], { type: mimeType });
        },
        'com.capawble.shared.platform.jsOpenVideoOverlay' : 
            (embedUrl) => {
              try {
                const overlay = document.createElement('div');
                overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.78)';
                const box = document.createElement('div');
                box.style.cssText = 'position:relative;width:min(92vw, 900px);aspect-ratio:16 / 9;max-height:88vh;background:#000;border-radius:12px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.5)';
                const iframe = document.createElement('iframe');
                iframe.src = embedUrl;
                iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; compute-pressure';
                iframe.allowFullscreen = true;
                iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
                const closeBtn = document.createElement('button');
                closeBtn.textContent = '×';
                closeBtn.setAttribute('aria-label', 'Close video');
                closeBtn.style.cssText = 'position:absolute;top:6px;right:8px;width:32px;height:32px;border:0;border-radius:50%;background:rgba(0,0,0,0.6);color:#fff;font-size:20px;line-height:1;cursor:pointer;z-index:1';
                const cleanup = () => { document.removeEventListener('keydown', onKey, true); overlay.remove(); };
                const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); cleanup(); } };
                closeBtn.addEventListener('click', cleanup);
                overlay.addEventListener('click', (e) => { if (e.target === overlay) cleanup(); });
                document.addEventListener('keydown', onKey, true);
                box.appendChild(iframe);
                box.appendChild(closeBtn);
                overlay.appendChild(box);
                document.documentElement.appendChild(overlay);
              } catch (e) {
                console.error('YouTube overlay failed', e);
              }
            }
            ,
        'com.capawble.shared.platform.navigatorOnLine' : () => navigator.onLine,
        'com.capawble.shared.platform.addOnlineListener' : (callback) => { window.addEventListener('online', callback); },
        'com.capawble.shared.platform.addOfflineListener' : (callback) => { window.addEventListener('offline', callback); },
        'com.capawble.shared.platform.jsPrefersReducedMotion' : () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches),
        'com.capawble.shared.platform.jsPickFile' : (accept, onResult, onCancel) => {
            var input = document.createElement('input');
            input.type = 'file';
            input.accept = accept;
            input.onchange = function() {
                var file = input.files[0];
                if (!file) { onCancel(); return; }
                var reader = new FileReader();
                reader.onload = function() {
                    var arr = new Uint8Array(reader.result);
                    var bytes = [];
                    for (var i = 0; i < arr.length; i++) { bytes.push(arr[i]); }
                    onResult(file.name, file.type, bytes);
                };
                reader.onerror = function() { onCancel(); };
                reader.readAsArrayBuffer(file);
            };
            input.click();
        },
        'com.capawble.shared.platform.jsArrayLength' : (arr) => arr.length,
        'com.capawble.shared.platform.jsArrayGet' : (arr, i) => arr[i],
        'com.capawble.shared.platform.jsFetchPut' : (url, contentType, rangeHeaderName, rangeHeaderValue, bytes, onSuccess, onError) => {
            var arr = new Uint8Array(bytes);
            var headers = { 'Content-Type': contentType };
            // Only when the server signed a ceiling. Sending the header against a URL signed without one
            // is a 403 just as surely as omitting it against one signed with it, and on web it also costs
            // a preflight the bucket must allow.
            if (rangeHeaderValue != null) { headers[rangeHeaderName] = rangeHeaderValue; }
            fetch(url, {
                method: 'PUT',
                headers: headers,
                body: arr
            })
            .then(function(response) {
                if (response.ok) { onSuccess(); }
                else { onError('Upload failed: ' + response.status); }
            })
            .catch(function(err) { onError(err.message || 'Upload failed'); });
        },
        'com.capawble.shared.platform.jsPrimaryPointerIsCoarse' : () => !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches),
        'com.capawble.shared.platform.jsCopyToClipboard' : (text, onSuccess, onError) => {
            navigator.clipboard.writeText(text)
                .then(function() { onSuccess(); })
                .catch(function(err) { onError(err.message || 'Clipboard write failed'); });
        },
        'com.capawble.shared.platform.jsNewArray' : (len) => new Array(len),
        'com.capawble.shared.platform.jsArraySet' : (arr, i, v) => { arr[i] = v; },
        'com.capawble.shared.platform.jsBrowserSharesText' : () => typeof navigator.share === 'function' &&
            (typeof navigator.canShare !== 'function' || navigator.canShare({ text: 'x' })),
        'com.capawble.shared.platform.jsShareText' : (text, title) => {
            if (navigator.share) {
                navigator.share({ text: text, title: title }).catch(function() {});
            } else {
                navigator.clipboard.writeText(text).catch(function() {});
            }
        },
        'com.capawble.shared.screens.parent.mydog.jsNewArray' : (len) => new Array(len),
        'com.capawble.shared.screens.parent.mydog.jsArraySet' : (arr, i, v) => { arr[i] = v; },
        'com.capawble.shared.screens.parent.mydog.jsNewInt32Array' : (len) => new Int32Array(len),
        'com.capawble.shared.screens.parent.mydog.jsInt32ArraySet' : (arr, i, v) => { arr[i] = v; },
        'com.capawble.shared.screens.parent.mydog.jsRenderCardToBlob' : (width, height, bgCenterColor, bgEdgeColor, textColor, confettiColors, dogName, dogPhotoUrl,
               emoji, title, subtitle, pawPixels, bonePixels, iconSize, logoPixels, logoWidth, logoHeight, framePixels, frameSize, pawDiskPixels, pawDiskSize, onSuccess, onError) => {
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
        
            // Radial gradient background (matches in-app dialog)
            var diagonal = Math.sqrt(width * width + height * height);
            var grad = ctx.createRadialGradient(width * 0.5, height * 0.4, 0, width * 0.5, height * 0.4, diagonal * 0.65);
            grad.addColorStop(0, bgCenterColor);
            grad.addColorStop(1, bgEdgeColor);
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, width, height);
        
            // Create canvases from pre-rendered pixel data (square or rectangular)
            function createPixelCanvas(pixels, w, h) {
                var c = document.createElement('canvas'); c.width = w; c.height = h;
                var ictx = c.getContext('2d');
                var imgData = ictx.createImageData(w, h);
                for (var p = 0; p < pixels.length; p++) {
                    var argb = pixels[p];
                    imgData.data[p * 4]     = (argb >> 16) & 0xFF; // R
                    imgData.data[p * 4 + 1] = (argb >> 8) & 0xFF;  // G
                    imgData.data[p * 4 + 2] = argb & 0xFF;          // B
                    imgData.data[p * 4 + 3] = (argb >> 24) & 0xFF; // A
                }
                ictx.putImageData(imgData, 0, 0);
                return c;
            }
            function createIconCanvas(pixels, sz) { return createPixelCanvas(pixels, sz, sz); }
            function tintIcon(srcCanvas, sz, color) {
                var c = document.createElement('canvas'); c.width = sz; c.height = sz;
                var tctx = c.getContext('2d');
                tctx.drawImage(srcCanvas, 0, 0);
                tctx.globalCompositeOperation = 'source-in';
                tctx.fillStyle = color;
                tctx.fillRect(0, 0, sz, sz);
                return c;
            }
            var pawArr = []; for (var p = 0; p < pawPixels.length; p++) pawArr.push(pawPixels[p]);
            var boneArr = []; for (var p = 0; p < bonePixels.length; p++) boneArr.push(bonePixels[p]);
            var logoArr = []; for (var p = 0; p < logoPixels.length; p++) logoArr.push(logoPixels[p]);
            var pawSrc = createIconCanvas(pawArr, iconSize);
            var boneSrc = createIconCanvas(boneArr, iconSize);
            var logoSrc = createPixelCanvas(logoArr, logoWidth, logoHeight);
            var frameArr = []; for (var p = 0; p < framePixels.length; p++) frameArr.push(framePixels[p]);
            var frameSrc = frameSize > 0 ? createIconCanvas(frameArr, frameSize) : null;
            var pawDiskArr = []; for (var p = 0; p < pawDiskPixels.length; p++) pawDiskArr.push(pawDiskPixels[p]);
            var pawDiskSrc = pawDiskSize > 0 ? createIconCanvas(pawDiskArr, pawDiskSize) : null;
        
            // Static confetti with paw prints, bones, circles, rectangles
            var confettiArr = [];
            for (var i = 0; i < confettiColors.length; i++) confettiArr.push(confettiColors[i]);
            var rng = (function(s) { return function() { s = (s * 1103515245 + 12345) & 0x7fffffff; return s / 0x7fffffff; }; })(42);
            for (var i = 0; i < 120; i++) {
                var cx = rng() * width;
                var cy = rng() * height;
                var color = confettiArr[Math.floor(rng() * confettiArr.length)] || bgCenterColor;
                var st = Math.floor(rng() * 100);
                if (st < 25) {
                    // Paw icon
                    var sz = 28 + rng() * 28;
                    var tinted = tintIcon(pawSrc, iconSize, color);
                    ctx.save(); ctx.translate(cx, cy); ctx.rotate(rng() * Math.PI * 2);
                    ctx.globalAlpha = 0.4;
                    ctx.drawImage(tinted, -sz / 2, -sz / 2, sz, sz);
                    ctx.restore();
                } else if (st < 50) {
                    // Bone icon
                    var sz = 28 + rng() * 28;
                    var tinted = tintIcon(boneSrc, iconSize, color);
                    ctx.save(); ctx.translate(cx, cy); ctx.rotate(rng() * Math.PI * 2);
                    ctx.globalAlpha = 0.4;
                    ctx.drawImage(tinted, -sz / 2, -sz / 2, sz, sz);
                    ctx.restore();
                } else if (st < 80) {
                    // Circle
                    var sz = 6 + rng() * 10;
                    ctx.globalAlpha = 0.4; ctx.fillStyle = color;
                    ctx.beginPath(); ctx.arc(cx, cy, sz / 2, 0, Math.PI * 2); ctx.fill();
                } else {
                    // Rectangle strip
                    var sz = 8 + rng() * 12;
                    ctx.globalAlpha = 0.4; ctx.fillStyle = color;
                    ctx.save(); ctx.translate(cx, cy); ctx.rotate(rng() * Math.PI);
                    ctx.fillRect(-sz * 0.6, -sz / 8, sz * 1.2, sz / 4);
                    ctx.restore();
                }
            }
            ctx.globalAlpha = 1.0;
        
            // Derive the photo radius from the frame raster size (frameSize = CARD_PHOTO_RADIUS * 4) so it
            // stays in lockstep with the commonMain photo radius without a duplicated literal. Fallback only
            // for the legacy no-frame path (frameSize 0), which no current caller hits.
            var photoRadius = frameSize > 0 ? frameSize / 4 : 230;
            var photoCenterX = width / 2;
            var photoCenterY = 380;
        
            function drawAfterPhoto() {
                // Tier laurel-crest frame composited over the photo (same frame as the My Dog profile screen)
                if (frameSrc) {
                    ctx.drawImage(frameSrc, photoCenterX - frameSize / 2, photoCenterY - frameSize / 2, frameSize, frameSize);
                }
        
                // Emoji badge overlay (bottom-right of photo circle)
                ctx.font = '80px serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(emoji, photoCenterX + photoRadius * 0.65, photoCenterY + photoRadius * 0.65);
        
                // Title (word wrap)
                ctx.fillStyle = textColor;
                ctx.font = 'bold 56px sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'top';
                var titleWords = title.split(' ');
                var titleLines = [];
                var titleCurrentLine = '';
                var titleMaxWidth = width - 120;
                for (var tw = 0; tw < titleWords.length; tw++) {
                    var titleTestLine = titleCurrentLine ? titleCurrentLine + ' ' + titleWords[tw] : titleWords[tw];
                    if (ctx.measureText(titleTestLine).width > titleMaxWidth && titleCurrentLine) {
                        titleLines.push(titleCurrentLine);
                        titleCurrentLine = titleWords[tw];
                    } else {
                        titleCurrentLine = titleTestLine;
                    }
                }
                if (titleCurrentLine) titleLines.push(titleCurrentLine);
                var titleY = photoCenterY + photoRadius + 60;
                for (var tl = 0; tl < titleLines.length; tl++) {
                    ctx.fillText(titleLines[tl], width / 2, titleY + tl * 70);
                }
        
                // Subtitle (word wrap)
                ctx.font = '40px sans-serif';
                ctx.globalAlpha = 0.85;
                var words = subtitle.split(' ');
                var lines = [];
                var currentLine = '';
                var maxWidth = width - 160;
                for (var w = 0; w < words.length; w++) {
                    var testLine = currentLine ? currentLine + ' ' + words[w] : words[w];
                    if (ctx.measureText(testLine).width > maxWidth && currentLine) {
                        lines.push(currentLine);
                        currentLine = words[w];
                    } else {
                        currentLine = testLine;
                    }
                }
                if (currentLine) lines.push(currentLine);
                var subtitleY = titleY + titleLines.length * 70 + 10;
                for (var l = 0; l < lines.length; l++) {
                    ctx.fillText(lines[l], width / 2, subtitleY + l * 50);
                }
                ctx.globalAlpha = 1.0;
        
                // Branding — wordmark on rounded white plate for contrast
                var logoDrawW = width * 0.275;
                var logoDrawH = logoDrawW * logoHeight / logoWidth;
                var logoX = (width - logoDrawW) / 2;
                var logoY = height - logoDrawH - 80;
        
                var plateHPad = 28;
                var plateVPad = 18;
                var plateX = logoX - plateHPad;
                var plateY = logoY - plateVPad;
                var plateW = logoDrawW + 2 * plateHPad;
                var plateH = logoDrawH + 2 * plateVPad;
                var plateR = 24;
        
                ctx.beginPath();
                if (ctx.roundRect) {
                    ctx.roundRect(plateX, plateY, plateW, plateH, plateR);
                } else {
                    ctx.moveTo(plateX + plateR, plateY);
                    ctx.arcTo(plateX + plateW, plateY, plateX + plateW, plateY + plateH, plateR);
                    ctx.arcTo(plateX + plateW, plateY + plateH, plateX, plateY + plateH, plateR);
                    ctx.arcTo(plateX, plateY + plateH, plateX, plateY, plateR);
                    ctx.arcTo(plateX, plateY, plateX + plateW, plateY, plateR);
                    ctx.closePath();
                }
                ctx.fillStyle = 'rgba(255,255,255,0.65)';
                ctx.fill();
                ctx.strokeStyle = 'rgba(12,93,0,0.15)';
                ctx.lineWidth = 2;
                ctx.stroke();
        
                ctx.drawImage(logoSrc, logoX, logoY, logoDrawW, logoDrawH);
        
                // Export as a blob for the platform's sharer (platform/FileSharing.wasmJs.kt)
                canvas.toBlob(function(blob) {
                    if (!blob) { onError('Failed to generate image'); return; }
                    onSuccess(blob);
                }, 'image/png');
            }
        
            function drawInitials() {
                // No photo — draw the paw placeholder disk (gray circle + paws) to match the live frame.
                if (pawDiskSrc) {
                    ctx.drawImage(pawDiskSrc, photoCenterX - pawDiskSize / 2, photoCenterY - pawDiskSize / 2, pawDiskSize, pawDiskSize);
                }
                drawAfterPhoto();
            }
        
            if (dogPhotoUrl) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = function() {
                    ctx.save();
                    // White border
                    ctx.beginPath();
                    ctx.arc(photoCenterX, photoCenterY, photoRadius + 4, 0, Math.PI * 2);
                    ctx.fillStyle = 'rgba(255,255,255,0.8)';
                    ctx.fill();
                    // Clip to circle
                    ctx.beginPath();
                    ctx.arc(photoCenterX, photoCenterY, photoRadius, 0, Math.PI * 2);
                    ctx.clip();
                    // Draw image covering the circle
                    var scale = Math.max(photoRadius * 2 / img.width, photoRadius * 2 / img.height);
                    var sw = img.width * scale;
                    var sh = img.height * scale;
                    ctx.drawImage(img, photoCenterX - sw / 2, photoCenterY - sh / 2, sw, sh);
                    ctx.restore();
                    drawAfterPhoto();
                };
                img.onerror = function() {
                    drawInitials();
                };
                img.src = dogPhotoUrl;
            } else {
                drawInitials();
            }
        },
        'com.capawble.shared.util.jsOpenUrl' : (url) => window.open(url, '_blank'),
        'com.capawble.shared.util.jsTimezoneOffsetMinutes' : () => -new Date().getTimezoneOffset(),
        'com.capawble.shared.util.jsTimeZoneId' : () => Intl.DateTimeFormat().resolvedOptions().timeZone,
        'com.capawble.shared.util.jsTimezoneOffsetMinutesAt' : (ms) => -new Date(ms).getTimezoneOffset(),
        'com.capawble.shared.util.jsLocalDatePacked' : () => { const d = new Date(); return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); },
        'com.capawble.shared.util.jsCurrentHour' : () => new Date().getHours(),
        'com.capawble.shared.util.jsCurrentMinute' : () => new Date().getMinutes(),
        'com.capawble.shared.util.localStorageGetItem' : (key) => window.localStorage.getItem(key),
        'com.capawble.shared.util.localStorageSetItem' : (key, value) => window.localStorage.setItem(key, value),
        'com.capawble.shared.util.localStorageRemoveItem' : (key) => window.localStorage.removeItem(key),
        'com.capawble.shared.util.jsFetchText' : (url) => fetch(url).then(r => r.ok ? r.text() : null).catch(() => null),
        'com.capawble.web.isDocumentHidden' : () => document.hidden,
        'com.capawble.web.addVisibilityChangeListener' : (callback) => { document.addEventListener('visibilitychange', callback); },
        'com.capawble.web.landing.consoleLog' : (msg) => { console.log(msg) },
        'com.capawble.web.landing.isLocalhost' : () => location.hostname === 'localhost',
        'com.capawble.web.landing.createObserverOptions' : () => ({threshold: 0.1}),
        'com.capawble.web.landing.observerCallback' : (entries, observer) => { for (const entry of entries) { if (entry.isIntersecting) { entry.target.style.opacity = '1'; entry.target.style.transform = 'translateY(0)'; } } },
        'com.capawble.web.landing.IntersectionObserver_$external_fun' : (p0, p1, isDefault0) => new IntersectionObserver(p0, isDefault0 ? undefined : p1, ),
        'com.capawble.web.landing.observe_$external_fun' : (_this, p0) => _this.observe(p0)
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './capawble-webApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],


    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject, { builtins: [''] });
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./capawble-webApp.wasm',import.meta.url).href), importObject, { builtins: [''] })).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
